import React, { useState } from 'react';
import cx from 'classnames';
import styles from './board.module.css';

export const BoardColumn = ({
  column,
  items = [],
  empty_text = 'No items',
  renderCard,
  onAdd,
  draggable = false,
  onCardDrop = () => {}
}) => {
  const [is_drag_over, setIsDragOver] = useState(false);

  const handleDragStart = (e, item) => {
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/plain', String(item.id || item._id));
  };

  const handleDragOver = (e) => {
    if (!draggable) return;
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    if (!is_drag_over) setIsDragOver(true);
  };

  const handleDragLeave = () => setIsDragOver(false);

  const handleDrop = (e) => {
    if (!draggable) return;
    e.preventDefault();
    setIsDragOver(false);
    const item_id = e.dataTransfer.getData('text/plain');
    if (item_id) onCardDrop(item_id, column.key);
  };

  return (
    <div className={styles.column}>
      <div className={styles.columnHeader} style={{ borderBottomColor: column.color }}>
        <span className={styles.columnTitle}>{column.label}</span>
        <span className={styles.columnBadge}>{items.length}</span>
      </div>
      <div
        className={cx(styles.columnBody, { [styles.columnBodyDragOver]: is_drag_over })}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        {onAdd && (
          <button type="button" className={styles.columnCreate} onClick={() => onAdd(column)}>
            + Create
          </button>
        )}
        {items.length === 0
          ? !onAdd && <div className={styles.empty}>{empty_text}</div>
          : items.map((item, index) =>
              draggable ? (
                <div
                  key={item.id || item._id || index}
                  draggable
                  onDragStart={(e) => handleDragStart(e, item)}
                  className={styles.draggableCard}
                >
                  {renderCard(item, index)}
                </div>
              ) : (
                renderCard(item, index)
              )
            )}
      </div>
    </div>
  );
};
